import { useState } from 'react';
import { totalUnread } from '../helpers/conversation-helper';
import ConversationService from '../services/conversation-service';
import SchoolService from '../services/school-service';
import StorageService from '../services/storage-service';
import usePolling from './use-polling';

const POLL_MS = 60000;

// The badge polls for the whole session; the school's uuid doesn't change, so it is asked for once.
let school: { id: number; uuid: Promise<string> } = null;

const schoolUuid = (): Promise<string> => {
  const schoolId = new StorageService().getEmployee().schoolId;
  if (school?.id !== schoolId) {
    const uuid = new SchoolService().getSchoolById(schoolId).then(found => found.uuid);
    school = { id: schoolId, uuid };
    uuid.catch(() => {
      if (school?.uuid === uuid) school = null;
    });
  }

  return school.uuid;
};

const fetchUnreadCount = async () => {
  const conversations = await new ConversationService(await schoolUuid()).listConversations();

  return totalUnread(conversations);
};

const useUnreadMessages = () => {
  const [totalUnreadCount, setTotalUnreadCount] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(true);

  // A failed poll keeps the last count on the badge rather than hiding it until the next success.
  const poll = () => fetchUnreadCount().catch(error => {
    console.error('Error fetching unread messages:', error);
    setLoading(false);
    throw error;
  });

  usePolling(poll, POLL_MS, {
    shareKey: 'conversations-unread',
    onData: total => {
      setTotalUnreadCount(total);
      setLoading(false);
    },
  });

  return { totalUnreadCount, loading };
};

export default useUnreadMessages;
